
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetoakkalkotcabs() {



    const cardData =
    {
        keyword: 'Pune to Akkalkot Cabs',
        heading: 'Platinum24 Cabs: Pune to Akkalkot Cabs',
        headingDescription: ' Platinum24 Cabs offers trusted Pune to Akkalkot Cabs, perfect for devotees visiting Shri Swami Samarth Maharaj Temple and nearby spiritual sites. Our fleet of hatchbacks, sedans, SUVs, and luxury cars ensures a safe and comfortable journey on this long-distance route. With professional chauffeurs familiar with the Pune–Akkalkot highway, we guarantee punctual pickups, convenient halts, and a smooth travel experience. Whether it’s a one-way drop, round-trip, or a family pilgrimage, Platinum24 Cabs provides affordable fares, transparent pricing, and reliable service to make your Pune to Akkalkot journey stress-free and spiritually fulfilling.',

        top: 'Top Places to Visit in Akkalkot with Platinum24 Cabs',

"topPlaces": [
  {
    "title": "Swami Samarth Maharaj Temple",
    "description": "The Swami Samarth Maharaj Temple is the spiritual heart of Akkalkot, dedicated to Shri Swami Samarth, believed to be the fourth incarnation of Lord Dattatreya. Devotees from all over India come here to seek blessings, peace, and guidance. The temple complex includes Swami’s Samadhi, sacred trees, and meditation halls. Daily aartis and bhajans create a deeply devotional atmosphere. Festivals like Swami Samarth Jayanti attract lakhs of pilgrims. The temple is Akkalkot’s divine center of faith."
  },
  {
    "title": "Vatavruksha Mandir",
    "description": "Vatavruksha Mandir is built around the sacred banyan tree under which Swami Samarth Maharaj spent most of his life in Akkalkot. The tree and temple complex radiate immense spiritual energy. Devotees believe darshan here fulfills wishes and grants protection. The site also includes Swami’s Padukas and meditation spots. Pilgrims feel a strong connection with Swami’s presence here. Vatavruksha Mandir is Akkalkot’s most revered spiritual landmark."
  },
  {
    "title": "Akkalkot Swami Math",
    "description": "Akkalkot Swami Math is one of the important mathas established for spreading Swami Samarth’s teachings. The math hosts daily rituals, bhajans, and community meals (Annadan). Devotees gather here to learn about Swami’s philosophy of compassion, service, and devotion. The math also supports charitable and educational activities. It serves as a hub for spiritual seekers. Swami Math is Akkalkot’s institution of spiritual learning."
  },
  {
    "title": "Hasthimal (Swami’s Devotee Residence)",
    "description": "The residence of Hasthimal, a devout disciple of Swami Samarth, is preserved as a holy site in Akkalkot. It showcases Swami’s personal interactions with his followers. Visitors can see artifacts and stories related to Swami’s miracles here. It provides a glimpse into the deep guru-bhakti tradition of the region. Pilgrims feel inspired by the simplicity and devotion of Hasthimal. This site is Akkalkot’s heritage of devotion."
  },
  {
    "title": "Cholappa Maharaj Samadhi",
    "description": "Cholappa Maharaj, one of Swami Samarth’s closest disciples, has a samadhi in Akkalkot. Devotees believe that worship at both Swami Samarth’s Samadhi and Cholappa Maharaj’s Samadhi completes the pilgrimage. The site is peaceful, ideal for meditation and prayer. Pilgrims learn about the guru-disciple bond here. Festivals and rituals are observed regularly. It is Akkalkot’s shrine of devotion and discipleship."
  },
  {
    "title": "Balappa Math",
    "description": "Balappa Math is dedicated to Balappa, another ardent devotee of Swami Samarth. The math preserves the stories and teachings of Swami’s interactions with Balappa. Devotees visit for blessings and to hear kirtans narrating Swami’s miracles. The math also contributes to community service and cultural preservation. Pilgrims experience spiritual calm in its serene atmosphere. Balappa Math is Akkalkot’s symbol of loyalty and devotion."
  },
  {
    "title": "Akkalkot Fort",
    "description": "Akkalkot Fort is a historical structure reflecting the Maratha and local dynasties’ rule. Though partly in ruins, it stands as a testimony to Akkalkot’s rich history. The fort has old gateways, bastions, and remnants of palaces. Visitors enjoy exploring its rustic charm and heritage significance. It provides panoramic views of the town. Akkalkot Fort is the town’s historical pride alongside its spiritual fame."
  },
  {
    "title": "Rajwada of Akkalkot",
    "description": "The Rajwada or Royal Palace of Akkalkot showcases the legacy of the royal family who were great patrons of Swami Samarth. The palace architecture blends Maratha and Deccan styles. Visitors admire the durbar halls, courtyards, and traditional designs. The Rajwada occasionally hosts cultural and religious events. It is a heritage site for history lovers. The Rajwada is Akkalkot’s royal touch of tradition."
  },
  {
    "title": "Community Annachhatra (Free Food Service)",
    "description": "Annachhatras in Akkalkot, especially near Swami Samarth Temple, provide free meals to thousands of devotees daily. Following Swami’s teachings of service, these kitchens serve simple but delicious meals. Pilgrims feel blessed to partake in prasad here. The system runs on donations and voluntary service. It represents compassion and equality. Annachhatras are Akkalkot’s living tradition of seva (selfless service)."
  },
  {
    "title": "Local Temples & Holy Tanks",
    "description": "Akkalkot also has smaller shrines and holy tanks associated with Swami Samarth’s life. Pilgrims bathe in these tanks before darshan as a ritual of purification. Temples dedicated to Lord Dattatreya and Hanuman are also popular here. These places preserve the spiritual aura of the town. Festivals and rituals make them lively and sacred. Together, they form Akkalkot’s extended divine circuit."
  }
],



    "services": [
    {
      "name": "Pune to Akkalkot Taxi Service",
      "description": "Comprehensive and reliable taxi service from Pune to Akkalkot, catering to pilgrims, tourists, and regular travelers. The service offers comfortable vehicles, timely pickups, and courteous drivers who ensure a safe and smooth journey to the holy town of Akkalkot, known for its spiritual significance and the famous Swami Samarth temple."
    },
    {
      "name": "Akkalkot Cab from Pune",
      "description": "Convenient cab options for travel from Pune to Akkalkot, including hatchbacks, sedans, SUVs, and tempo travellers. Ideal for solo travelers, families, and groups seeking hassle-free transportation with flexible timings and on-demand services."
    },
    {
      "name": "Pune Akkalkot Taxi Booking",
      "description": "Easy and instant taxi booking service from Pune to Akkalkot available through online platforms and phone calls. Choose your preferred vehicle type and get immediate confirmation with transparent pricing and customer support for a seamless travel experience."
    },
    {
      "name": "Taxi for Akkalkot Pilgrimage Pune",
      "description": "Dedicated pilgrimage taxi services from Pune to Akkalkot offering customized itineraries for devotees visiting the Swami Samarth temple and other religious sites. Comfortable and well-maintained vehicles with knowledgeable drivers familiar with pilgrimage routes and timings."
    },
    {
      "name": "Pune to Akkalkot Car Rental",
      "description": "Flexible car rental options for Pune to Akkalkot trips including self-drive and chauffeur-driven vehicles. Choose from a wide range of cars, perfect for personal trips, family outings, or group travels, with options for hourly, daily, or trip-based rentals."
    },
    {
      "name": "Akkalkot Taxi Packages Pune",
      "description": "Value-for-money taxi packages from Pune to Akkalkot including fuel, tolls, driver allowance, and optional sightseeing stops. Packages are customizable based on the duration of your trip, vehicle preference, and number of passengers, offering complete peace of mind for your pilgrimage or leisure travel."
    },
    {
      "name": "Affordable Cab Pune to Akkalkot",
      "description": "Budget-friendly taxi options from Pune to Akkalkot without compromising on comfort or safety. These affordable cabs are perfect for travelers seeking economical yet reliable transportation services to reach Akkalkot smoothly and on time."
    },
    {
      "name": "Pune Akkalkot Private Taxi",
      "description": "Exclusive private taxi services from Pune to Akkalkot providing privacy, convenience, and flexibility. Perfect for families or groups who prefer a dedicated vehicle and driver, with the ability to plan stops and travel schedules as per their needs."
    },
    {
      "name": "Pune to Akkalkot Taxi Fare",
      "description": "Transparent and competitive taxi fare details for Pune to Akkalkot trips with no hidden charges. Get fare estimates based on your choice of vehicle, trip duration, and travel dates, helping you budget your pilgrimage or trip accurately."
    },
    {
      "name": "Akkalkot Cab Charges Pune",
      "description": "Comprehensive fare structure and charges for cab services from Pune to Akkalkot, covering all applicable costs like fuel, tolls, driver allowance, and taxes. This allows travelers to make informed decisions and select the best taxi option suited to their budget."
    },
    {
      "name": "Pune to Akkalkot Taxi Hire",
      "description": "Flexible taxi hire service from Pune to Akkalkot with options for short-term or long-term rentals. Whether you need a taxi for a quick round trip or an extended pilgrimage tour, these hire services provide dependable and comfortable vehicles."
    },
    {
      "name": "Akkalkot Temple Taxi Service Pune",
      "description": "Specialized taxi service catering to devotees visiting the revered temples of Akkalkot. The service ensures timely arrival and departure with vehicles equipped for long journeys, making your spiritual trip peaceful and enjoyable."
    },
    {
      "name": "Pune to Akkalkot One Way Cab",
      "description": "Economical one-way cab service from Pune to Akkalkot, perfect for travelers who do not require a return trip. Pay only for the distance traveled and enjoy hassle-free point-to-point travel with professional drivers and clean vehicles."
    },
    {
      "name": "Pune Akkalkot Taxi with Driver",
      "description": "Experienced and courteous drivers provided with every Pune to Akkalkot taxi booking to ensure a safe and comfortable journey. Drivers are familiar with the best routes and local conditions, enhancing your travel experience."
    },
    {
      "name": "Taxi Service Pune to Akkalkot",
      "description": "Full-service taxi options covering Pune to Akkalkot routes for all traveler needs including local transfers, pilgrimage tours, family trips, and corporate travel. Services are available 24/7 with online booking and customer support to assist you throughout your journey."
    }
  ],
  "tableData": [
    ["Pune to Akkalkot Taxi Service", "Akkalkot Cab from Pune"],
    ["Pune Akkalkot Taxi Booking", "Taxi for Akkalkot Pilgrimage Pune"],
    ["Pune to Akkalkot Car Rental", "Akkalkot Taxi Packages Pune"],
    ["Affordable Cab Pune to Akkalkot", "Pune Akkalkot Private Taxi"],
    ["Pune to Akkalkot Taxi Fare", "Akkalkot Cab Charges Pune"],
    ["Pune to Akkalkot Taxi Hire", "Akkalkot Temple Taxi Service Pune"],
    ["Pune to Akkalkot One Way Cab", "Pune Akkalkot Taxi with Driver"],
    ["Taxi Service Pune to Akkalkot", "—"]
  ],


        "whychoose": [
    {
      "WhyChooseheading": "Reliable Pune to Akkalkot Cab Service",
      "WhyChoosedescription": "Platinum24 Cabs offers comfortable and trustworthy cab rides from Pune to Akkalkot for a seamless travel experience."
    },
    {
      "WhyChooseheading": "Experienced Drivers Familiar with Pune-Akkalkot Routes",
      "WhyChoosedescription": "Our skilled drivers know the best routes to ensure a safe and timely journey."
    },
    {
      "WhyChooseheading": "Clean and Well-Maintained Vehicles",
      "WhyChoosedescription": "Travel in spacious, sanitized, and air-conditioned cabs perfect for long-distance trips."
    },
    {
      "WhyChooseheading": "Flexible Booking for One-Way and Round Trips",
      "WhyChoosedescription": "Choose from customizable packages that fit your travel itinerary."
    },
    {
      "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
      "WhyChoosedescription": "Enjoy upfront pricing that includes fuel, tolls, and driver allowances for a worry-free ride."
    },
    {
      "WhyChooseheading": "24/7 Customer Support for Hassle-Free Booking",
      "WhyChoosedescription": "Our dedicated support team is available round the clock to assist with your booking needs."
    },
    {
      "WhyChooseheading": "Comfortable Ride Ideal for Families and Groups",
      "WhyChoosedescription": "Our cabs cater to all travel needs, whether for family vacations, group tours, or business trips."
    },
    {
      "WhyChooseheading": "Multiple Vehicle Options to Suit Your Needs",
      "WhyChoosedescription": "Select from hatchbacks, sedans, or SUVs based on your group size and luggage requirements."
    }
  ]































    }


const faqData = [
    {
        question: 'Does Platinum24 Cabs provide cab services from Pune to Akkalkot?',
        answer: 'Yes, Platinum24 Cabs offers reliable and comfortable cab services for travel between Pune and Akkalkot.',
    },
    {
        question: 'How can I book a Pune to Akkalkot cab with Platinum24 Cabs?',
        answer: 'You can easily book your Pune to Akkalkot cab through our website, mobile app, or by contacting our customer support team.',
    },
    {
        question: 'What types of vehicles are available for Pune to Akkalkot trips?',
        answer: 'We offer a variety of vehicles including sedans, SUVs, and premium cars to suit your travel preferences and group size.',
    },
    {
        question: 'Are the drivers experienced for long-distance travel like Pune to Akkalkot?',
        answer: 'Yes, all our drivers are professional, experienced, and knowledgeable about the Pune to Akkalkot route.',
    },
    {
        question: 'Can I book a round trip cab from Pune to Akkalkot?',
        answer: 'Absolutely! We provide round-trip cab services with flexible scheduling to accommodate your travel plans.',
    },
    {
        question: 'What is included in the fare for Pune to Akkalkot cab services?',
        answer: 'The fare includes vehicle charges, driver allowance, fuel, tolls, and taxes. Additional charges may apply for extra stops or waiting time.',
    },
    {
        question: 'Can I customize pickup and drop-off locations for Pune to Akkalkot rides?',
        answer: 'Yes, you can specify your preferred pickup and drop-off points along the Pune-Akkalkot route.',
    },
    {
        question: 'Are safety measures in place for Pune to Akkalkot cab rides?',
        answer: 'All vehicles are regularly sanitized, and our drivers follow strict safety protocols for your protection.',
    },
    {
        question: 'Is it possible to hire a cab for multiple days for Pune to Akkalkot travel?',
        answer: 'Yes, we offer hourly and multi-day rental packages tailored to your travel needs.',
    },
    {
        question: 'Does Platinum24 Cabs provide corporate taxi services from Pune to Akkalkot?',
        answer: 'Yes, we offer customized corporate travel solutions including priority support and flexible billing for Pune to Akkalkot routes.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Rajesh Patil',
        feedback: 'The Pune to Akkalkot cab service by Platinum24 Cabs was punctual and the vehicle was very comfortable.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Anjali More',
        feedback: 'I had a wonderful trip to Akkalkot with Platinum24 Cabs. The booking process was easy and the driver was professional.',
        rating: 5,
    },
];









































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "pune-cab-service" },
        { place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "pune-taxi-hire" },
        { place: "/images/keyword/3.jpg", text: "Pune Online Cab Booking", link: "pune-online-cab-booking" },
        { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "best-cab-service-in-pune" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cabs", link: "pune-to-mumbai-cabs" },
        { place: "/images/keyword/6.jpg", text: "Pune to Nashik Cabs", link: "pune-to-nashik-cabs" },
        { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "pune-to-mahabaleshwar-cabs" },
        { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cabs", link: "pune-to-lonavala-cabs" },
        { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
        { place: "/images/keyword/10.jpg", text: "Pune to Bhimashankar Cab", link: "pune-to-bhimashankar-cab" },
        { place: "/images/keyword/11.jpg", text: "Pune to Konkan Darshan Cabs", link: "pune-to-konkan-darshan-cabs" },
        { place: "/images/keyword/12.jpg", text: "Pune Outstation Cabs", link: "pune-outstation-cabs" },
        { place: "/images/keyword/13.jpg", text: "Ashtavinayak Darshan Cab", link: "ashtavinayak-darshan-cab" },
        { place: "/images/keyword/14.jpg", text: "Pune to Goa Cabs", link: "pune-to-goa-cabs" },
        { place: "/images/keyword/15.jpg", text: "Cabs Services Near Me", link: "cabs-services-near-me" },
        { place: "/images/keyword/16.jpg", text: "Corporate Cab Service in Pune", link: "corporate-cab-service-in-pune" },
        { place: "/images/keyword/17.jpg", text: "Pune to Mumbai Airport Cabs", link: "pune-to-mumbai-airport-cabs" },
        { place: "/images/keyword/18.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
        { place: "/images/keyword/20.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },
        { place: "/images/keyword/21.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
        { place: "/images/keyword/23.jpg", text: "Ertiga On Rent in Pune", link: "ertiga-on-rent-in-pune" },
        { place: "/images/keyword/24.jpg", text: "Pune to Sambhaji Nagar Taxi", link: "pune-to-sambhaji-nagar-taxi" },
        { place: "/images/keyword/25.jpg", text: "Pune to Ganpatipule Taxi", link: "pune-to-ganpatipule-taxi" }
    ];










const puneToAkkalkotCabsSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Akkalkot Cabs",
  "image": "https://www.platinum24cab.com/assets/images/pune-to-akkalkot-cab.jpg",
  "description": "Book Pune to Akkalkot cab with Platinum24 Cabs. Comfortable AC taxis, private cars, and tempo travellers available for pilgrimage to Shri Swami Samarth Temple in Akkalkot. Reliable drivers and flexible packages.",
  "brand": {
    "@type": "Brand",
    "name": "Platinum24 Cabs"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3299",
    "availability": "https://schema.org/InStock",
    "url": "https://www.platinum24cab.com/pune-to-akkalkot-cabs"
  }
};





    return (
        <div>
<Helmet>
  <title>Pune to Akkalkot Cabs | Swami Samarth Temple Taxi | Platinum24 Cabs</title>
  <meta
    name="description"
    content="Book Pune to Akkalkot cab service with Platinum24 Cabs. AC taxis, tempo travellers & car rentals for temple visits. Affordable one-way & round trip options with expert drivers."
  />
  <meta
    name="keywords"
    content="Pune to Akkalkot Taxi Service, Akkalkot Cab from Pune, Pune Akkalkot Taxi Booking, Taxi for Akkalkot Pilgrimage Pune, Pune to Akkalkot Car Rental, Akkalkot Taxi Packages Pune, Affordable Cab Pune to Akkalkot, Pune Akkalkot Private Taxi, Pune to Akkalkot Taxi Fare, Akkalkot Cab Charges Pune, Pune to Akkalkot Taxi Hire, Akkalkot Temple Taxi Service Pune, Pune to Akkalkot One Way Cab, Pune Akkalkot Taxi with Driver, Taxi Service Pune to Akkalkot"
  />
  <script type="application/ld+json">
    {JSON.stringify(puneToAkkalkotCabsSchema)}
  </script>
</Helmet>

            <div
                className="breadcumb-wrapper"
                // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                        <div className="breadcumb-menu-wrap">
                        </div>
                    </div>
                </div>
            </div>










            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/35.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>
                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        <div className="service-icon">
                                            🚖
                                        </div>
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Platinum24 Cabs</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Platinum24 Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917507048333" className="pc-call">+91 7507048333</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/917507048333"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917507048333" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@platinum24cab.com" className="pc-email">
                                            booking@platinum24cab.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Platinum24 Cabs</strong><br />
                                            OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL
                                            FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetoakkalkotcabs;